import React, { FC, memo } from 'react';

import { FlexRow, ProgressBar } from '@portal/common/components';
import { styled } from '@portal/common/theme';
import formatPercentage from '@portal/common/utility/formatting/formatPercentage';

import _ from '../../locale/_';

const StyledTitle = styled('div')(({ theme }) => ({
    fontWeight: theme.typography.fontWeight.bold,
}));

const EmphasizedText = styled('span')(({ theme }) => ({
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.color.green1,
}));

const Summary = styled('div')(({ theme }) => ({
    width: '45%',
    textAlign: 'left',
}));

const Name = styled(FlexRow)(({ theme }) => ({
    width: '25%',
}));

const LeftShift = styled('div')<{ width?: number }>(({ theme, width = 31 }) => ({
    width,
}));

const progressBarStyle = { width: '25%' };

type Props = {
    name: string;
    prefix: string | undefined;
    totalItems: number[];
    items: number[];
    percentage: number;
    marginLeft?: number;
    icon?: React.ReactNode;
    dataProjectName?: string;
    dataName?: string;
};

export const SummaryRow: FC<Props> = memo(
    ({ totalItems, items, name, dataName, dataProjectName, percentage, marginLeft, icon }) => {
        const summary = [
            <span key={0}>
                {`Contains `}
                <EmphasizedText>{formatPercentage(percentage)}</EmphasizedText>
                {` of ${dataProjectName || dataName || ''}`}
            </span>,
        ];
        if (items != null && totalItems != null) {
            summary.push(<span key={1}>{` (${items} out of ${totalItems})`}</span>);
        }

        return (
            <FlexRow justify="space-between" align="center" grow={1}>
                <Name>
                    {icon || <LeftShift width={marginLeft} />}
                    <StyledTitle>{name}</StyledTitle>
                </Name>
                <Summary>{summary}</Summary>
                <ProgressBar
                    inProgress
                    now={Math.ceil(percentage * 100)}
                    style={progressBarStyle}
                />
            </FlexRow>
        );
    }
);

export default SummaryRow;
